import { useParams } from 'react-router';
import React from 'react';
import TeamsChannelModel from './teamsBody';
import SlackChannelModel from './slackBody';

const ChannelMainBody = () => {
  const { channel } = useParams<{ channel: string }>();
  return (
    <>
    { ((channel as string).toLowerCase() === 'ms teams')
        && (<TeamsChannelModel />)}
    { ((channel as string).toLowerCase() === 'slack')
        && (<SlackChannelModel />)}
    </>
  );
};

export default ChannelMainBody;